<template>
  <div>
    <v-snackbar
        v-for="notification in notifications"
        :key="notification.id"
        :value="true"
        :timeout="notification.temporal ? notification.dismissCountDown * 1000 : -1"
        :color="notification.type"
        :dismissible="notification.dismissible">

      {{ notification.content }}

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            v-bind="attrs"
            @click="dismissNotification(notification.id)">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NotificationComponent',

  computed: {
    ...mapGetters({
      notifications: 'notification/notifications'
    })
  },

  methods: {
    ...mapActions({
      dismissNotification: 'notification/dismiss'
    })
  }
};
</script>
